module.exports = __webpack_public_path__ + "static/img/case-1data.42951753.jpg";